import type { EcommerceEcoupon } from '../api/cart/responses/cartResponses';

export const isUnappliedActiveEcoupon = (
    ecoupon: Pick<EcommerceEcoupon, 'active' | 'triggeredPromotion' | 'isDirty'>,
) => ecoupon.active && !ecoupon.triggeredPromotion && !ecoupon.isDirty;
